import axios from "axios";
import {appConfig} from "config/defaultConfig";

// @todo Get Conure endpoint for ALL environments. Add to config.json(s)
const CONURE_SERVICES = appConfig.APP.CONURE_SERVICES;
const IROH_SERVICES = appConfig.APP.IROH_SERVICES;

/**
 * Create a new investigation from an array of observables.
 * @param {Array} observables Array of observables
 * @returns {String} Unique Investigation ID
 */
export function createNewInvestigation(observables) {
  return axios
    .post(`${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}`, {
      observables: observables
    })
    .then((resp) => resp.data);
}

/**
 * Given a query string. Call Inspection endpoint
 * and return the identified observables.
 *
 * @param {String} query Query String
 * @returns {Array} Array of inspected observables
 */
export function inspectInvestigationQuery(query) {
  return axios
    .post(`${IROH_SERVICES.ROUTES.INSPECT}`, {content: query})
    .then((resp) => resp.data);
}

export function fetchInvestigationStatus(id) {
  return axios
    .get(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.STATUS}`
    )
    .then((resp) => resp.data);
}

export function fetchInvestigationSummary(id) {
  return axios
    .get(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.SUMMARY}`
    )
    .then((resp) => resp.data);
}

/**
 * Fetch an Investigations Graph data.
 *
 * @todo Endpoint not configured for cross-origin requests. Engine team looking into it.
 * When available, enable fetch request and remove mock data.
 *
 * @param {String} id An Investigation Id
 * @returns Investigation Response
 */
export function fetchInvestigationGraph(id) {
  return axios
    .get(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.GRAPH}`
    )
    .then((resp) => resp.data);
}

/**
 * Fetch an Investigations Events data.
 *
 * @param {String} id An Investigation Id
 * @returns Investigation Events Response
 */
export function fetchInvestigationEvents(id) {
  return axios
    .get(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.EVENTS}`
    )
    .then((resp) => resp.data);
}

/**
 *
 * @param {String} id CTIA Investigation Id.
 * @returns {Promise<String>} Conure Id for the same saved investigation.
 */
export function fetchSavedSnapshot(id) {
  return axios
    .get(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.SNAPSHOT}`
    )
    .then((resp) => resp.data);
}

/**
 * Save an Investigation.
 *
 * @param {String} id
 * @param {Object} payload
 * @returns
 */
export function createSavedInvestigation(id, payload) {
  return axios
    .put(
      `${window.CONFIG.conureServiceUri}${CONURE_SERVICES.INVESTIGATION}/${id}${CONURE_SERVICES.SAVE}`,
      payload
    )
    .then((resp) => resp.data);
}
